// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1-Dhh","col":"styles_col__1BT73"};